/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserName } from './UserName';

export type AdminSlideFlag = {
    readonly id?: number;
    readonly slide_id?: number;
    readonly order_id?: number;
    priority?: AdminSlideFlag.priority;
    reason: AdminSlideFlag.reason;
    note?: string | null;
    readonly created_at?: string;
    readonly updated_at?: string;
    readonly user?: UserName;
    readonly slide_name?: string;
}

export namespace AdminSlideFlag {

    export enum priority {
        LOW = 'low',
        NORMAL = 'normal',
        URGENT = 'urgent',
    }

    export enum reason {
        MISSING_EPIDERMIS = 'missing-epidermis',
        EMBEDDED_INCORRECTLY = 'embedded-incorrectly',
        TANGENTIAL_SECTION = 'tangential-section',
        MISLABELED = 'mislabeled',
        DATA_ENTRY_ERROR = 'data-entry-error',
        INCORRECT_ORDER = 'incorrect-order',
        BLURRY = 'blurry',
        TILING = 'tiling',
        SCAN_MISSING_TISSUE = 'scan-missing-tissue',
        INCOMPLETE_SCAN = 'incomplete-scan',
        FOLDED_TISSUE = 'folded-tissue',
        TISSUE_OUT_OF_SCAN_FIELD = 'tissue-out-of-scan-field',
        AIR_BUBBLE = 'air-bubble',
        NO_COVERSLIP = 'no-coverslip',
        ORGANISM_RESCAN = 'organism-rescan',
        FORTYX_RESCAN = 'fortyx-rescan',
        REPEAT_STAIN = 'repeat-stain',
        OTHER = 'other',
    }


}
